// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContactType extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
        Customer: 1,
        Dealer: 2,
        Vendor: 3,
        Other: 4,
    };
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
}

